import axios from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery, useMutation } from "react-query";

export const useGetAffiliators = () => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    return useQuery({
        queryKey: ['get-affiliators'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators`, { headers });
            } catch (err: any) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
                throw err;
            }
        },
    });
};

export const useAddAffiliator = () => {
    const headers = useAuthHeaders();

    return useMutation({
        mutationFn: async (data: any) => {
            return await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators`, data, { headers });
        }
    });
};

export const useUpdateAffiliator = () => {
    const headers = useAuthHeaders();

    return useMutation({
        mutationFn: async ({ id, data }: { id: number; data: any }) => {
            return await axios.put(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators/${id}`, data, { headers });
        }
    });
};

export const useDeleteAffiliator = () => {
    const headers = useAuthHeaders();

    return useMutation({
        mutationFn: async (id: number) => {
            return await axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators/${id}`, { headers });
        }
    });
};

export const useGetWithdrawals = () => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    return useQuery({
        queryKey: ['get-withdrawals'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators/withdrawals`, { headers });
            } catch (err: any) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
                throw err;
            }
        },
    });
};

export const useApproveWithdrawal = () => {
    const headers = useAuthHeaders();

    return useMutation({
        mutationFn: async (id: number) => {
            return await axios.put(`${process.env.REACT_APP_API_ENDPOINT}/admin/affiliators/withdrawals/${id}/approve`, {}, { headers });
        }
    });
};
